import React, { useEffect, useState, useRef, useCallback } from 'react';
import { EquityStakeBlock, TokenBbookBlock } from './components/equityStakeBlock';
import { BuyingEquityButton } from './components/buyingEquityButton';
import { TotalRoundsBlock } from './components/totalRoundsBlock';
import { TotalAllocationBlock } from './components/totalAllocationBlock';
import { EquityPoolBlock } from './components/equityPoolBlock';
import { DividendsBlock } from './components/dividendsBlock';
import { NavigationBar } from './components/navigationBar';
import { TopBar } from './components/topBar.js';
import './App.css';
import { TransactionHistory } from './components/transactionHistory.js';
import { PartnersBlock } from './components/partnerBlock.js';
import { SelectDep } from './components/selectDep.js';
import { Loading } from './components/loading.js';
import { Project } from './components/project.js';
import { Turl } from './components/tUrl.js'
import { GiftBlock } from './components/giftBlock.js';
import { Card } from './components/card.js';
import { EmailVerificationFlow } from './components/emailVerificationFlow.js';
import { addLocale, useLocale } from 'ttag';

import en from './i18n/en.po.json';
import uk from './i18n/uk.po.json';
import ru from './i18n/ru.po.json';
import es from './i18n/es.po.json';
import de from './i18n/de.po.json';
import fr from './i18n/fr.po.json';
import it from './i18n/it.po.json';
import pl from './i18n/pl.po.json';
import zh from './i18n/zh.po.json';
import vi from './i18n/vi.po.json';
import id from './i18n/id.po.json';
import th from './i18n/th.po.json';
import hi from './i18n/hi.po.json';
import ar from './i18n/ar.po.json';
import tr from './i18n/tr.po.json';
import { mixpanel } from './components/mp.js';

addLocale('uk', uk);
addLocale('en', en);
addLocale('ru', ru);
addLocale('es', es);
addLocale('de', de);
addLocale('fr', fr);
addLocale('it', it);
addLocale('pl', pl);
addLocale('zh', zh);
addLocale('vi', vi);
addLocale('id', id);
addLocale('th', th);
addLocale('hi', hi);
addLocale('ar', ar);
addLocale('tr', tr);



const tg = window.Telegram && window.Telegram.WebApp ? window.Telegram.WebApp : null;

function getLoc() {

  let lng = localStorage.getItem("lng") || 'en'
  return lng
}

function App() {
  const [locale, setlocalee] = useState(getLoc());
  useLocale(locale);
  const [index, setIndex] = useState(0);
  const [isMiniApp, setIsMiniApp] = useState(false);
  const [showError, setShowError] = useState(false);
  const [recData, setRecData] = useState();
  const [isDoDep, setisDoDep] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const hasFetchedData = useRef(false);

  const upd = () => {
    setRecData(null)
    sendAuthData()
  }


  const sendAuthData = async () => {
    hasFetchedData.current = true;
    try {
      const _userData = tg ? tg.initData : null;
      let userData = { initData: _userData }

      //console.log(userData);

      if (userData) {
        const response = await fetch(Turl + '/api/auth', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(userData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        let rd = await response.json();
        // console.log(rd);
        //setLocal(getLocale())
        setRecData(rd);
      } else {
        console.warn("Telegram user data not available.");
      }

    } catch (error) {
      console.error('Authentication error:', error);
    }
  };

  useEffect(() => {

    //if (tg.initData) {
      if (tg) {
      setIsMiniApp(true);
    } else {
      setShowError(true);
    }

    if (tg && !recData && !hasFetchedData.current) {
      try {
        const userData = window.Telegram.WebApp.initDataUnsafe?.user;
        if (userData) {
          mixpanel.identify(userData.id);
        }
      } catch (error) {

      }

      sendAuthData();
    }
  }, [tg, recData]); // Зависимости useEffect

  if (showError) {
    return (
      <div className="error-container">
        <p>This application is designed to be used inside Telegram Mini Apps.</p>
      </div>
    );
  }

  if (!recData) {
    return <Loading />;
  }
  hasFetchedData.current = false;

  const closeModal = () => {
    setErrorMessage('');
    upd();
  };

  const l1 = (
    <>
      <TokenBbookBlock amount={recData.bbk} />
      <BuyingEquityButton handlesetIndex={setIndex} index={index} />
      <TotalRoundsBlock round={recData.cs.round} price_bif={recData.cs.price_bif} price_now={recData.cs.price_now} price_after={recData.cs.price_after} />
      <TotalAllocationBlock totalbbk={839455702} soldbbk={recData.cs.soldbbk} roundalocatoin={recData.cs.roundalocatoin} />
      <EquityPoolBlock equity_pool={recData.cs.equity_pool} ep_paid={recData.cs.ep_paid} round={recData.cs.round} price_after={recData.cs.price_after} round_sell={recData.cs.round_sell} roundalocatoin={recData.cs.roundalocatoin} />

    </>
  );

  const l2 = (
    <TransactionHistory />
  );

  const l3 = (
    <PartnersBlock />
  );

  const l4 = (
    recData.user.email ?
      <SelectDep handlesetIndex={setIndex} setIsAuthorized={upd} wallet={recData.wallet} depWallet={recData.depWallet} isDoDep={isDoDep} setisDoDep={setisDoDep} setErrorMessage={setErrorMessage} />
      :
      <EmailVerificationFlow handlesetIndex={setIndex} setIsAuthorized={upd} wallet={recData.wallet} depWallet={recData.depWallet} isDoDep={isDoDep} setisDoDep={setisDoDep} setErrorMessage={setErrorMessage} />
  );
  const l5 = (
    <Project />
  );

  const l6 = (
    <GiftBlock />
  );
  const l7 = (
    <Card amount={recData.bbk} adr={recData.cardAdress} handlesetIndex={setIndex}/>
  );

  return (
    <div className="dashboard-container">
      <TopBar handlesetIndex={setIndex} index={index} setIsAuthorized={upd} setlocale={setlocalee} />
      {index === 0 && l1}
      {index === 1 && l2}
      {index === 2 && l3}
      {index === 3 && l5}
      {index === 4 && l4}
      {index === 5 && l6}
      {index === 6 && l7}
      <NavigationBar handlesetIndex={setIndex} index={index} />
      {errorMessage && (
        <div className="modal">
          <div className="modal-content">
            <span className="close-button" onClick={closeModal}>&times;</span>
            <p className="error-message">{errorMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;